<img class="card-logo" [src]="getIconToDisplay()">
<div class="card-body">
  <!-- <pre>{{item.status | json}}</pre> -->
  <p class="cat-card-title">{{ item.name }}
  </p>
  <p class="card-text">{{ item.baseSkuNumber }}</p>
</div>
